/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetTasterResponse } from '../models/GetTasterResponse';
import type { PostTasterRequest } from '../models/PostTasterRequest';
import type { PutTasterRequest } from '../models/PutTasterRequest';
import type { WrappedMany_GetTasterResponse_ } from '../models/WrappedMany_GetTasterResponse_';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TastersService {

    /**
     * Read Many
     * @param limit
     * @param offset
     * @returns WrappedMany_GetTasterResponse_ Successful Response
     * @throws ApiError
     */
    public static readManyV1TastersGet(
        limit: number = 20,
        offset?: number,
    ): CancelablePromise<WrappedMany_GetTasterResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/tasters/',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create
     * @param requestBody
     * @param verifyEmail
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createV1TastersPost(
        requestBody: PostTasterRequest,
        verifyEmail: boolean = true,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/tasters/',
            query: {
                'verify_email': verifyEmail,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Read One
     * @returns GetTasterResponse Successful Response
     * @throws ApiError
     */
    public static readOneV1TastersCurrentGet(): CancelablePromise<GetTasterResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/tasters/current',
        });
    }

    /**
     * Read One Platform
     * @param tasterId
     * @returns GetTasterResponse Successful Response
     * @throws ApiError
     */
    public static readOnePlatformV1TastersReadOneTasterIdGet(
        tasterId: any,
    ): CancelablePromise<GetTasterResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/tasters/read_one/{taster_id}',
            path: {
                'taster_id': tasterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update
     * @param id
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static updateV1TastersIdPut(
        id: string,
        requestBody: PutTasterRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/tasters/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete
     * @param id
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteV1TastersIdDelete(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/tasters/{id}',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
